<template>
  <div class="b-pop-up__header-container">
    <div class="b-pop-up__mini-title b-pop-up__mini-title--orange">
      {{ dictionary.villageClub }}
    </div>
    <div class="b-pop-up__header">
      <div class="b-pop-up__header-holder">
        <div class="b-pop-up__header__title">
          {{ dictionary.modalTitle }}
        </div>
        <div class="b-pop-up__header__text">
          {{ dictionary.modalDescription }}
        </div>
      </div>
      <CloseModal v-if="!hideButton" class="b-pop-up__close" @close="emit('close')" />
    </div>
  </div>
</template>

<script setup>
import {
  getData,
} from '../../../lib/lib'
import CloseModal from './CloseModal.vue'

const { dictionary } = getData('loginModalData')

const props = defineProps({
  hideButton: { default: false, type: Boolean },
})


const emit = defineEmits(['close'])

</script>